import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";

export namespace NetworkONTValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                isOnline: v.optional(v.boolean()),
            }),
        }),
    );

    export const Update = defineValidation(
        v.object({
            label: v.exactOptional(baseVals.string()),
        }),
    );

    export const CreateWAN = defineValidation(
        v.object({
            type: v.picklist(["IP", "PPP"] as const),
            mode: v.picklist(["Route", "Bridge"] as const),
            useVlan: v.boolean(),
            vlanId: baseVals.intRange(10, 4080, "VLAN ID"),
            username: v.optional(baseVals.string()),
            password: v.optional(baseVals.string()),
        }),
    );

    export const DeleteWAN = defineValidation(
        v.object({
            oid: baseVals.string(),
        }),
    );

    export const UpdateWAN = defineValidation(
        v.object({
            oid: baseVals.string(),
            mode: v.picklist(["Route", "Bridge"] as const),
            useVlan: v.boolean(),
            vlanId: baseVals.intRange(10, 4080, "VLAN ID"),
            username: v.optional(baseVals.string()),
            password: v.optional(baseVals.string()),
        }),
    );

    export const UpdateLAN = defineValidation(
        v.object({
            oid: baseVals.string(),
            wanBinding: baseVals.string(),
        }),
    );

    export const UpdateWiFi = defineValidation(
        v.object({
            oid: baseVals.string(),
            ssid: baseVals.string(),
            visible: v.boolean(),
            useAuth: v.boolean(),
            password: v.optional(baseVals.string()),
            wanBinding: v.optional(baseVals.string()),
        }),
    );

    export const UpdateSystem = defineValidation(
        v.object({
            password: v.exactOptional(baseVals.string()),
        }),
    );

    export const CreateSubscriptionWAN = defineValidation(
        v.object({
            subscriptionId: baseVals.string(),
        }),
    );

    export namespace API {
        export const PonInfoUser = defineValidation(
            v.object({
                search: baseVals.string(),
            }),
        );
    }
}
